// Server timestamps are timezone-aware ISO strings ("2026-07-28T11:57:00Z"),
// but older data may be naive UTC ("2026-07-28 11:57:00") with no offset.
export const parseServerDate = (value: string): Date => {
  const iso = value.replace(' ', 'T');
  const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/.test(iso);
  return new Date(hasTimezone ? iso : iso + 'Z');
};

/**
 * Clock-face duration: "2:14:07". Hours are unpadded (sessions cap at 12h),
 * minutes and seconds always two digits. Days only appear for stale data —
 * live sessions auto-close after 12 hours.
 */
export const formatClock = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const clock = `${hours}:${pad(minutes)}:${pad(secs)}`;
  return days > 0 ? `${days}d ${clock}` : clock;
};

/** Row metadata time: "Scanned at 21:04". */
export const formatScanTime = (value: string): string =>
  parseServerDate(value).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });

/** Leaderboard date column: "26 Jul 26" — day, short month, two-digit year. */
export const formatShortDate = (value: string): string =>
  parseServerDate(value).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  });

/** Leaderboard date column on desktop, where the extra width is free: "26 July 2026". */
export const formatLongDate = (value: string): string =>
  parseServerDate(value).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
